import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import {
  getTruckCharacteristicAPI,
  getTruckTypeById,
  patchTruckTypeById,
  patchTruckTypeStatus,
  postTruckTypesAPI,
} from "../../../../../api/modules";

// react-bootstrap components
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Badge,
} from "react-bootstrap";
import { errorToast, successToast } from "../../../../../services/toastService";
import LogInput from "../../../../../components/atoms/LogInput";
import LogButton from "../../../../../components/atoms/LogButton";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import ContentHeader from "../../../components/molecules/ContentHeader";
import ModalQuestion from "../../../../../components/organisms/modal-question/ModalQuestion";
import LogSelectMulti from "../../../../../components/atoms/LogSelectMultiCustom";
import { COLOR_PRIMARY, COLOR_RED } from "../../../../../constants/Colors";

const BtnInvisible = styled(Button)`
  background: none;
  border: none;
  &:hover {
    opacity: 0.7;
    background: none !important;
    color: black !important;
    border: none;
  }
  &:active {
    opacity: 0.7;
    background: none !important;
    color: black !important;
    border: none;
  }
  &:focus {
    opacity: 0.7;
    background: none !important;
    color: black !important;
    border: none;
  }
`;
const BadgeLog = styled(Badge)`
  background-color: ${COLOR_PRIMARY};
  color: white;
  border-radius: 5px !important;
  text-align: center;
  display: inline-block;
  padding: 0px 20px;
`;

const BadgeLogRed = styled(Badge)`
  background-color: ${COLOR_RED};
  color: white;
  border-radius: 5px !important;
  text-align: center;
  display: inline-block;
  padding: 0px 20px;
`;

const RowDeleteStyled = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  right: 15px;
  justify-content: flex-end;
  position: absolute;
  top: 10px;
`;

const CardLogBootstrapStyled = styled(Card)`
  padding: 10px;
  border-radius: 15px;
`;

function EditTruckType() {
  const params = useParams();
  const { id } = params;
  const [modalExit, setModalExit] = useState(false);
  const history = useHistory();
  const [entity, setEntity] = useState(null);
  const [characteristic, setCharacteristic] = useState([]);

  useEffect(() => {
    if (id) {
      fetchData();
    } else {
      setEntity(null);
    }
  }, [id]);
  const fetchData = async () => {
    if (id) {
      const { msg, detail } = await getTruckTypeById(id);
      const { truckChars } = await getTruckCharacteristicAPI();
      if (truckChars) {
        setCharacteristic(
          truckChars.map((l) => ({
            _id: l._id,
            label: l.truck_characteristic_name,
            value: l._id,
          }))
        );
      }

      if (detail) {
        setEntity(detail);
      } else {
        errorToast(msg || "Intente nuevamente");
      }
    }
  };

  let ProfileSchema = Yup.object().shape({
    truck_type_name: Yup.string().required(
      `Nombre del Tipo es obligatorio`
    ),
    truckCharacteristics: Yup.array()
      .min(1, "Debe seleccionar al menos una característica")
      .required("Este campo es obligatorio"),
  });

  const handleDeleteItem = async (id) => {
    const { msg, detail } = await patchTruckTypeStatus(id);
    if (detail) {
      setEntity(detail);
      successToast(
        `Tipo ${detail?.status ? "Activado" : "Desactivado"} exitosamente`
      );
    } else {
      errorToast(msg || "Intente nuevamente");
    }
  };

  const handleCloseExitModal = async (response) => {
    if (response) {
      await handleDeleteItem(entity?._id);
      setModalExit(false);
    } else {
      setModalExit(false);
    }
  };

  const RowDelete = () => {
    return entity?._id ? (
      <RowDeleteStyled>
        <OverlayTrigger
          key="delete"
          overlay={
            <Tooltip id={`delete`}>
              {entity.status ? "Desactivar" : "Activar"}
            </Tooltip>
          }
        >
          <BtnInvisible
            onClick={(event) => {
              event.stopPropagation();
              setModalExit(true);
            }}
          >
            {entity.status ? (
              <BadgeLog className="cursor-pointer" as="h5">
                Activo
              </BadgeLog>
            ) : (
              <BadgeLogRed className="cursor-pointer" as="h5">
                Inactivo
              </BadgeLogRed>
            )}
          </BtnInvisible>
        </OverlayTrigger>
      </RowDeleteStyled>
    ) : (
      ""
    );
  };

  const handleSubmitAPI = async (values) => {
    let body = null;
    body = {
      ...values,
    };
    const response = await patchTruckTypeById(id, body);
    const { msg, detail } = response;
    if (detail) {
      successToast("Tipo editado con éxito");
      setEntity(detail);
    } else {
      errorToast(msg);
    }
  };

  return (
    <>
      <Container fluid>
        <Formik
          enableReinitialize
          initialValues={{
            truck_type_name: entity?.truck_type_name || "",
            truckCharacteristics: entity?.truckCharacteristics?.map(
              (l) => l._id
            ),
          }}
          validationSchema={ProfileSchema}
          onSubmit={(values, { setSubmitting }) => {
            handleSubmitAPI(values);
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            resetForm,
            dirty,
          }) => (
            <Row>
              <ContentHeader
                className={`ml-3`}
                title={`Editá Tipo`}
              />
              <Col md="12">
                <CardLogBootstrapStyled className="shadow-4dp pt-3 mb-3">
                  <CardLogBootstrapStyled.Body>
                    <RowDelete />
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <label className="text-primary font-weight-bold">
                            Edita el nombre del Tipo
                          </label>
                          <LogInput
                            placeholder="Ingresá Tipo"
                            type="text"
                            name="truck_type_name"
                            onChange={(e) => {
                              const { value } = e.target;
                              setFieldValue("truck_type_name", value);
                            }}
                            onBlur={handleBlur}
                            errors={errors}
                            value={values?.truck_type_name}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={12}>
                        <Form.Group>
                          <label className="text-primary font-weight-bold">
                            Modifica Características
                          </label>
                          <LogSelectMulti
                            placeholder="Características"
                            className="mt-1"
                            name="truckCharacteristics"
                            items={characteristic}
                            onChange={(v) => {
                              setFieldValue("truckCharacteristics", v);
                            }}
                            onBlur={handleBlur}
                            searchable={true}
                            disabled={characteristic.length === 0}
                            errors={errors}
                            value={values.truckCharacteristics}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </CardLogBootstrapStyled.Body>
                </CardLogBootstrapStyled>
              </Col>

              <Col md={6} className="text-center text-md-left">
                <LogButton
                  className="mt-4"
                  size="lg"
                  title={`Guardar cambios`}
                  color="primary"
                  border="curve"
                  block
                  onClick={() => {
                    if (!dirty) {
                      errorToast("Introduzca cambios");
                    } else {
                      handleSubmit();
                    }
                  }}
                />
              </Col>
              {dirty && (
                <Col md={6} className="text-center text-md-right">
                  <LogButton
                    className="mt-4"
                    size="lg"
                    color="secondary"
                    title={`Cancelar`}
                    border="curve"
                    block
                    onClick={resetForm}
                  />
                </Col>
              )}

              <div className="clearfix"></div>
              <ModalQuestion
                title={
                  `${!entity?.status ? "Activar " : "Desactivar "}` +
                  entity?.truck_type_name
                }
                subTitle="¿Estás seguro?"
                isShow={modalExit}
                handleClose={handleCloseExitModal}
              />
            </Row>
          )}
        </Formik>
      </Container>
    </>
  );
}

export default EditTruckType;
